import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  appointmentsList: [],
  appointmentItemsList: [],
  appointmentDetails: null,
  techFieldList: [],
  totalPages: 0,
  technicianAvailability: [],
  appointmentByApptId: null,
  validateAppointmentRequest: null,
};

export const AppointmentSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setAppointmentsList: (state, action) => {
      state.appointmentsList = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setTechnicianAvailability: (state, action) => {
      state.technicianAvailability = action.payload;
    },
    setAppointmentByApptId: (state, action) => {
      state.appointmentByApptId = action.payload;
    },
    resetAppointmentByApptId: (state) => {
      state.appointmentByApptId = null;
    },
    setAppointmentItemsList: (state, action) => {
      state.appointmentItemsList = action.payload.data;
    },
    setAppointmentDetails: (state, action) => {
      state.appointmentDetails = action.payload;
    },
    setTechFieldList: (state, action) => {
      state.techFieldList = action.payload;
    },
    validateAppointmentRequest: (state, action) => {
      state.validateAppointmentRequest = action.payload;
    },
  },
});

export const {
  setTechnicianAvailability,
  setAppointmentByApptId,
  resetAppointmentByApptId,
  setAppointmentsList,
  setAppointmentItemsList,
  setAppointmentDetails,
  setTechFieldList,
  validateAppointmentRequest,
} = AppointmentSlice.actions;

export default AppointmentSlice.reducer;
